import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConSultaModel} from 'src/app/model/Consulta.model';
import { JardinModel, ResponseJardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mensajeria',
  templateUrl: './mensajeria.component.html',
  styleUrls: ['./mensajeria.component.css']
})
export class MensajeriaComponent implements OnInit {

  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  palabraClave: string;
  consultas: Array<ConSultaModel>;
  page: number = 1;
  totalRec : number;
  modalData: {
    consulta: ConSultaModel;
    jardin:JardinModel;
  };
  
  constructor(
    private api: apiService,
    private spinner: NgxSpinnerService,
    private modal: NgbModal,
  ) { }

  ngOnInit(): void {
    this.palabraClave = "";
    this.spinner.show();
    this.page=1;
    this.totalRec=0;
    this.cargaInicial();
  }


  cargaInicial(){
    this.loadTable(null );
  }

  buscar(){
    this.loadTable(null);
  }

  loadTable(event?:PageEvent){
    this.page = event != null ? Number(event) : 1;
    this.spinner.show();
    this.api.API_POST_obtenerTodasLasConsultas(this.page,10,this.palabraClave).subscribe((response: any) => {
      this.consultas = response.payload.list;
      this.totalRec = response.payload.total;
      this.spinner.hide();
    },
    (err) => {
      console.log(err)
      this.spinner.hide();
    })
  }

  public getServerData(event?:PageEvent){
    this.loadTable(event != null ? event : null );
  }


  responder(consulta : ConSultaModel){
    this.spinner.show();
    this.api.API_POST_obtenerJardinPorIdJardinPeriodo(consulta.idJardinPeriodo).subscribe((response:ResponseJardinModel) => {
      this.api.dataJardin = response.payload;
      let jardin = response.payload;
      this.spinner.hide();
      this.modalData = { consulta, jardin };
      this.modal.open(this.modalContent, { size: 'lg' });
    },
    (err) => { 
      console.log(err)
    })
   
  }


  enviarRespuesta(modalData){
    this.spinner.show();

    if(modalData.consulta.respuesta != null){
      this.api.API_POST_actualizarConsulta(modalData.consulta).subscribe((response: any) => {
        this.loadTable(null );
        this.modal.dismissAll();
        this.spinner.hide();
      },
      (err) => {
        console.log(err)
        this.spinner.hide();
      })
    }else{
      this.spinner.hide();
      Swal.fire({
        title: 'UPS!',
        text: 'Debe Ingresar una Respuesta',
        icon: 'info',
        confirmButtonText: 'OK'
      })
    }
  }

}
